export default __webpack_public_path__ + "static/media/img_finished.8657dd39.png";